<template>
  <div>
    <a-input-number 
      :min="record.options.min" 
      :max="record.options.max" 
      :precision="record.options.precision" 
      :style="{width: (record.options && record.options.unit !== '' && record.options.unit !== undefined && record.options.unit !== null) ? '90%' : '100%'}" 
      :placeholder="record.options.placeholder"
      />
    <label
      v-if="record.options && record.options.unit !== '' && record.options.unit !== undefined && record.options.unit !== null"
      v-text="record.options.unit"
      style="margin-left: 10px;"
    ></label>
  </div>
</template>
<script>

export default {
  name: "kNumber",
  props: {
    record: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      // NONE
    };
  },
  methods: {
    // NONE
  }
};
</script>
